
import { defineComponent } from 'vue';
import smtWebSocket from '@/utils/websocket/smtWebSocket';

export default defineComponent({
  name: 'TvConnectCapsule',
  emits: ['connected', 'disconnected', 'message'],
  data() {
    return {
      wsConnected: false,
      isConnecting: false,
      connectRequested: false,
      offConnectionChange: null as null | (() => void),
    };
  },
  computed: {
    buttonText(): string {
      if (this.wsConnected) {
        return '已连接';
      }
      if (this.isConnecting) {
        return '连接中';
      }
      return '点击\n开启投屏';
    },
    capsuleClass(): string {
      if (this.wsConnected) {
        return 'is-connected';
      }
      if (this.isConnecting) {
        return 'is-connecting';
      }
      return 'is-disconnected';
    },
    buttonDisabled(): boolean {
      return this.isConnecting || this.wsConnected;
    },
  },
  mounted() {
    this.offConnectionChange = smtWebSocket.onConnectionChange((connected) => {
      const wasConnected = this.wsConnected;
      this.wsConnected = connected;
      if (connected) {
        this.isConnecting = false;
        this.connectRequested = true;
        if (!wasConnected) {
          this.$emit('connected');
        }
        return;
      }
      if (wasConnected) {
        this.$emit('disconnected');
      }
      this.isConnecting = this.connectRequested;
    });
    this.connectRequested = true;
    this.wsConnected = smtWebSocket.isConnected();
    this.isConnecting = !this.wsConnected && this.connectRequested;
    smtWebSocket.ensureConnected();
  },
  beforeUnmount() {
    if (this.offConnectionChange) {
      this.offConnectionChange();
    }
  },
  methods: {
    startConnect() {
      if (this.isConnecting || this.wsConnected) {
        return;
      }
      if (!smtWebSocket.getToken()) {
        return;
      }
      this.connectRequested = true;
      this.isConnecting = true;
      smtWebSocket.ensureConnected();
    },
    handleClick() {
      if (!this.wsConnected && !this.isConnecting) {
        this.startConnect();
      }
    },
  },
});
